// extracted by mini-css-extract-plugin
export default {"label":"_15GIO","mxLabel":"ddbW4","labelText":"NCY6T","mxLabelTxt":"_1Txmh","adCount":"_351MY","mxAdCount":"_16xvP","mxAdMsg":"dwTGk"};